export const ENTERPRISE_CONTACT_EMAIL = 'hello@aslgo.com';

/**
 * The Enterprise tier is sold by contact, not self-serve, so it is not in
 * PACKAGES. This row sits at the end of each package list as a plain,
 * non-selectable line: "Enterprise" … "contact us" with a mailto link.
 * `tone` matches the surrounding list: `light` for cards, `dark` for the
 * in-call minutes pill.
 */
export function EnterpriseContactRow({ tone = 'light', compact = false }: { tone?: 'light' | 'dark'; compact?: boolean }) {
  const border = tone === 'dark' ? 'border-white/15 text-white' : 'border-ink-200 dark:border-white/10 text-ink-900 dark:text-ink-100';
  const muted = tone === 'dark' ? 'text-white/80' : 'text-ink-600 dark:text-ink-400';
  const pad = compact ? 'p-2 text-[0.85rem]' : 'p-3';
  return (
    <div className={`flex items-center justify-between gap-3 rounded-lg border ${pad} ${border}`}>
      <span className="font-semibold">Enterprise</span>
      <span className={`whitespace-nowrap ${compact ? 'text-[0.75rem]' : 'text-[0.8rem]'} ${muted}`}>
        <a href={`mailto:${ENTERPRISE_CONTACT_EMAIL}`} className="font-medium underline underline-offset-2">
          contact us
        </a>
      </span>
    </div>
  );
}
